<div
  [ngClass]="{
    'div-item-cert': true,
    process: status === 'VALIDATION_IN_PROGRESS',
    error: status === 'ERROR',
    success: status === 'SUCCESS'
  }"
>
  <svg
    class="div-item-cert__border"
    aria-hidden="true"
    focusable="false"
  >
    <rect rx="12" ry="12"></rect>
  </svg>
  <ng-container *ngIf="status === 'without_uploading_document'">
    <ion-icon name="attach-outline" class="clip-icon" aria-hidden="true"></ion-icon>
    <p>
      <button
        type="button"
        class="link link-button"
        (click)="fileInput.click(); $event.stopPropagation(); setDocumentType()"
        [attr.aria-label]="'Selecciona ' + title"
      >
        Selecciona</button>
      <span class="document-title">{{ title }}</span>
    </p>
  </ng-container>

  <!-- procesando archivo -->
  <ng-container *ngIf="status === 'VALIDATION_IN_PROGRESS'">
    <div class="diplay-gap">
      <div class="spinner-wrapper">
        <ion-spinner name="circular" color="medium"></ion-spinner>
      </div>
      <p class="text-mb">
        <span>{{ title }}...</span>
      </p>
    </div>

    <div class="diplay-gap">
      <button class="primary-button" (click)="cancel()">Cancelar</button>
    </div>
  </ng-container>

  <!-- Documento cargado  -->
  <ng-container *ngIf="status === 'ERROR' || status === 'SUCCESS'">
    <div class="diplay-gap">
      <!-- Documento error -->
      <div class="div-error" *ngIf="status === 'ERROR'">
        <span class="div-error__symbol" aria-hidden="true">!</span>
      </div>
      <ion-icon name="checkmark-circle" *ngIf="status === 'SUCCESS'"></ion-icon>
      <p>{{ title }}</p>
    </div>
    <div class="diplay-gap">
      <button class="primary-button delete-button" (click)=" fileInput.value = ''; delDocument()">Eliminar</button>
    </div>
  </ng-container>

  <label [for]="'document-file-' + type" class="document-file-label">{{ title }}</label>
  <input
    type="file"
    hidden
    #fileInput
    [id]="'document-file-' + type"
    accept=".pdf, .jpg, .jpeg"
    (change)="onFileSelected($event)"
  />
</div>
<span *ngIf="status === 'ERROR'" class="text-error">
  {{ errorMessage }}
</span>
<span
  *ngIf="status === 'without_uploading_document' && errorCustomFile"
  class="text-error"
>
  Hubo un error al seleccionar este documento. Por favor, verifica el tipo o el
  tamaño del archivo.
</span>
